import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PaymentService } from 'src/app/services/payment/user-wallet.service';
import { GenericMessage } from 'src/app/shared/generic-message/generic-message.component';

interface RefundSource {
  id: string;
  label: string;
  type: 'vpa' | 'phone' | string;
  value: string;
  display?: string;
}

@Component({
  selector: 'app-redeem-tokens',
  templateUrl: './redeem-tokens.component.html',
  styleUrls: ['./redeem-tokens.component.scss'],
})
export class RedeemTokensComponent implements OnInit {
  amount: string = '';
  loading = false;
  isSubmitting = false;

  sources: RefundSource[] = [];
  selectedId: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<RedeemTokensComponent>,
    private paymentService: PaymentService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.fetchWalletInfo();
  }

  private fetchWalletInfo(): void {
    this.loading = true;
    this.paymentService.getWalletInfo().subscribe({
      next: (resp) => {
        const list: RefundSource[] = [];


        if (resp?.icici_user_config) {
          const cfg = resp.icici_user_config;
          list.push({
            id: `icici-${cfg.id ?? '1'}`,
            label: cfg.name ?? 'ICICI Wallet',
            type: 'vpa',
            value: cfg.vpa ?? '',
            display: cfg.vpa ?? '',
          });
        }


        if (Array.isArray((resp as any).refund_sources)) {
          (resp as any).refund_sources.forEach((s: any, i: number) => {
            if (!list.some((l) => l.value === s.value)) {
              list.push({
                id: s.id ?? `srv-${i}`,
                label: s.label ?? s.name ?? 'Refund Source',
                type: s.type ?? (s.value && s.value.includes('@') ? 'vpa' : 'phone'),
                value: s.value,
                display: s.display ?? s.value,
              });
            }
          });
        }

        this.sources = list;
        this.selectedId = this.sources.length ? this.sources[0].id : null;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        const message =
          (err && err.error && (err.error.detail?.message || err.error.message)) ||
          err?.message ||
          'Failed to load wallet info.';
        this.dialog.open(GenericMessage, { data: { title: 'Error', message } });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  selectSource(id: string): void {
    this.selectedId = id;
  }

  openAddNew(): void {

    this.dialogRef.close('add-new');
  }

  redeem(): void {
    const amountNum = Number(this.amount);
    if (!this.amount || isNaN(amountNum) || amountNum <= 0) {
      this.dialog.open(GenericMessage, { data: { title: 'Invalid amount', message: 'Please enter a valid amount to redeem.' } });
      return;
    }
    if (!this.selectedId) {
      this.dialog.open(GenericMessage, { data: { title: 'No refund source', message: 'Please select a refund source.' } });
      return;
    }
    const selected = this.sources.find((s) => s.id === this.selectedId);
    if (!selected || !selected.value) {
      this.dialog.open(GenericMessage, { data: { title: 'Invalid source', message: 'Selected refund source is invalid.' } });
      return;
    }

    this.isSubmitting = true;
    const payload = {
      amount: amountNum,
      payee_vpa: selected.value,
      remark: 'payout initiated from p2p web',
    };

    this.paymentService.initiatePayout(payload).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        const message = res?.message || 'Redeem request submitted and is being processed.';
        this.dialog.open(GenericMessage, { data: { title: 'Redeem requested', message } });
        this.dialogRef.close('success');
      },
      error: (err) => {
        this.isSubmitting = false;
        const message =
          (err && err.error && (err.error.detail?.message || err.error.message)) ||
          err?.message ||
          'Failed to initiate payout. Please try again later.';
        this.dialog.open(GenericMessage, { data: { title: 'Error', message } });
      },
    });
  }
}
